import React, { useContext } from "react";
import { Intro } from "components/commons";
import { DownloadProgressModal } from "components/modals";
import locale from "localization";
import SalesTransactionFilter from "./sales-transaction-filter";
import useDataTable from "hooks/useDataTable";
import DataTableV2 from "components/commons/data-table/data-table-v2";
import { StationContext } from "contexts";
import { getTransactions } from "apis/transactions";
import { initialFilterState } from "./sales-transaction-filter.state";
import { mapFilterToRequest, mapDataToList } from "./sales-transaction.mapper";
import { salesTransactionColumns } from "./sales-transaction-column";
import styles from "./sales-transaction.module.scss";
import { generateReport } from "apis/generate-report.api";
import useExport from "hooks/useExport";

const SalesTransactionModule = () => {
  const { station } = useContext(StationContext);

  const { filter, search, table } = useDataTable({
    api: {
      api: getTransactions,
      params: {
        page: 1,
        perPage: 10,
        stationCode: station.stationCode,
      },
      mapper: (param) => {
        return param;
      },
    },
    filter: { initialState: initialFilterState(), mapper: mapFilterToRequest },
    table: {
      key: "transactions",
      mapper: (transactions) => mapDataToList({ transactions }),
      columns: salesTransactionColumns,
    },
  });

  const exports = useExport({
    api: generateReport,
    reportType: "transaction",
    mappedFilterState: {
      ...filter?.mappedFilterState,
      stationCode: station.stationCode,
      searchKey: search?.searchKey,
    },
  });

  return (
    <>
      <DownloadProgressModal {...exports.downloadProgressModal} />
      <Intro title={locale.salesTransactioHistoryReport} />
      <SalesTransactionFilter {...filter} {...search} {...exports} />
      <div className={styles.table}>
        <DataTableV2 {...table} />
      </div>
    </>
  );
};

export default SalesTransactionModule;
